import * as React from "react";

function IconDeviceLaptopOff({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-laptop-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/device-laptop-off"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 19h16" /><path d="M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1" /><path d="M3 3l18 18" /></svg>;
}

export default IconDeviceLaptopOff;